<template>
    <div :class="{listContainer100: inWindow}">
       
        <div class="bundleContent" :class="{height100: inWindow}">
            <div>
                <div  class="is-size-5 has-text-weight-bold has-text-dark listTitleBar">

                    <div>
                        <div class="is-inline-block bundleHeader">
                            <div class="is-inline-block has-text-coolGreen handCursor has-background-grey is-size-3" >&nbsp;&nbsp;</div>
                           <!--  <div v-if="showBundleTree" class="bundleSubTree" @click="stopProp">
                                <span class="delete bundleSubTreeX" @click="showBundleTree = false"></span>
                                <div class="top5">
                                    <tree2 v-for="(item, index) in rootBundle" 
                                        :key="index" 
                                        :listName="item.listName" 
                                        :children="item.children" 
                                        :depth="0" 
                                        :id="item.id" 
                                        :rootBundleId="conts.id"
                                        :isDirty="item.dirt"
                                        :beenShared="item.beenShared"
                                        :path="[]">
                                    </tree2>
                                </div>
                            </div> -->
    <!-- Breadcrumbs -->
                            <div class="is-inline" v-for="(name, i) in this.breadCrumbs" :key="i">
                                <span class="subBack" :class="{'breadCrumbsRoot' : i==0, 'has-text-azGrey': i > 0}">{{name.listName}}</span> <span v-if="i < breadCrumbs.length -1" class="has-text-grey-light"> <span class="has-text-azGrey"> &gt; </span> </span>  
                            </div>
                            <i v-show="!inWindow && !$root.app.bundlesOpen" class="fa fa-window-maximize is-size-6 handCursor is-pulled-right" @click="$parent.openWindow(conts.id, listIndex)"></i>&nbsp;
                        
                             <!-- <i v-if="conts.imported" class="fas fa-cloud-download-alt has-text-coolGreen is-pulled-right right-10 is-size-7 handCursor top-5"></i> -->
                           <!--  <i v-if="conts.beenShared" class="fas fa-cloud-upload-alt is-pulled-right right3 is-size-7  top-5" :class="{red: data.dirt > 0, 'has-text-coolGreen': data.dirt == 0}" ></i> -->
                        
                        </div>
                    </div>
    
                  
                </div>
            </div>
            <transition name="slide" type="out-in">
                <div v-show="$root.app.bundlesOpen || inWindow" :class="{height100: inWindow}">
    <!-- subBundles -->
                    <div class="subBundleListShared has-background-dark">
                        &nbsp;&nbsp;
                       <!-- <div class="anglesBt has-background-dark" v-show="breadCrumbs.length > 1" @click="upLevel"><i class="fas fa-angle-double-left has-text-white"></i></div> -->


                      <!--  <sub-bundle-drop v-if="!info.children" ref="subBundle" class="is-inline left-18" :subBundle="{}" :theInd="0" :bundleId="data.id"></sub-bundle-drop> -->
                       <sub-bundle ref="subBundle" class="is-inline" v-for="(subBundle, theInd) in conts.children" :key="theInd" :subBundle="subBundle" :theInd="theInd" :bundleId="data.id"></sub-bundle>
            

                    </div>

                    <!--  <div v-show="!$parent.isPush">
                        <div class="bundleNotes">
                            <div class="top5 bottom5">
                                <span class=""><b>Notes</b></span>
                                <div ref="bNotesPubl" class="top3 bundleNotesNote is-size-6" >{{data.pubNote}}</div>
                            </div>
                        </div>
                    </div> -->
                    
    <!-- bundle -->
                    <div class="wobuList updateBundle" :class="{height100: inWindow}" ref="items">
                       <!--  <div v-if="!inWindow && !conts.items.length" class="noUpdates is-inline-block has-text-grey-light is-size-6"><b>[ No updates to push in this bundle, but other sub bundles have updates ]</b> </div> -->
                        <span v-if="!inWindow">&nbsp;</span>
                        <span v-show="conts.items.length && ($parent.isPush || $parent.upd)" @click="checkAll" class="toggleAllButton"><button class="button is-small left10 top-5">Select All</button></span>
                        <span v-show="conts.items.length && ($parent.isPush || $parent.upd)" @click="unIncludeAll" class="toggleAllButton"><button class="button is-small left10 top-5">Deselect All</button></span><br v-if="$parent.isPush || $parent.upd">
                        <!-- <span v-show="conts.items.length && ($parent.isPush || $parent.upd)" @click="toggleAll" class="left10">Include/Uninclude All: <input type="checkbox" checked/>  </span><br v-if="$parent.isPush || $parent.upd"> -->
                        <div v-show="$parent.showBundleCards" class="wobuCardContainer" v-for="(item, index) in conts.items" :key=index>
                             <card-shared v-bind:cardInfo="item" :shareId="shareId" :sel="false" ref="card"></card-shared> <!-- v-bind:listIndex="listIndex" -->
                        </div> 

                        <div v-if="info.children == undefined"  class="is-loading top60" id="spinner"></div>
            
                       <!--  <trans-drop-zone v-bind:itemIndex="conts.items.length" :style="[!$root.app.showImages ? {height: '63px'} : {}]"></trans-drop-zone> --> <!-- v-bind:listIndex="listIndex"  -->
                    </div>
                </div>  
                  
            </transition>
        </div>
        <!--  <div v-if="this.listIndex == az.page().currOpenWindow" class="bundleInWindow is-size-5 has-background-dark has-text-white">
            &nbsp;<span class="has-text-grey"><b>::</b></span> <span class="has-text-white"><b> {{rootName}} </b></span> <i class="fa fa-window-maximize is-size-6 handCursor" @click="$parent.closeWindow(conts.id, listIndex)"></i>&nbsp;
            <div class="is-size-7 has-text-white "><span style="position: relative; top: 3px">&nbsp;&nbsp;&nbsp;Currently Displayed in floating Window</span></div>
         </div>    -->
    </div>
</template>

<script>
import UrlCard from './UrlCard.vue'
import Tree2 from './Tree2.vue'
import TransDropZone from './TransDropZone.vue'
import ModalNewSub from '../components/ModalNewSub'
import SubBundle from '../components/SubBundle'
import CardShared from '../components/CardShared'
import SubBundleDrop from '../components/SubBundleDrop'
import bFactory from '../shared/bundleFactory.js'
import { AZEventBus } from '../components/AZEventBus'
import { Drag, Drop } from 'vue-drag-drop'

export default {
    name: 'bundlesharedupdate',
    components: {UrlCard, TransDropZone, Drop, Tree2, SubBundle, SubBundleDrop, CardShared},
    props: {
        info: {
            type: Object,
            default: function(){return {}}
        },
        listIndex: Number,
        inWindow: {
            type: Boolean,
            default: false
        },
        shareId: {
            type: Number,
            default: undefined
        },
        isUnCat: {
            type: Boolean,
            default: false
        }
    },
    data: function(){
        return {
            dragging: false,
            breadCrumbs: [],
            data: {items: [], children: []},
            sortDirection: true,
            showBundleTree: false,
            rootName: '',
            az: az,
            bc: [],
            branch: [],
            includeAll: true
            
        }
    },

    mounted: function(){
        //this.info.children = []
        this.data = this.info 
        //this.data.items.sort(function(a,b){ return a.p - b.p})       

        AZEventBus.$on('bundleDeleted', msg => {
           if(msg.id == this.conts.id && !this.conts.isRoot){
               this.upLevel()
           }
        })

        AZEventBus.$on('removeBundleFromCardsParents', msg => {
           if(msg.id == this.conts.id){
               this.removeBundleFromCardsParents()
           }
        })

        AZEventBus.$on('closeAllMenus', msg => {
            this.showBundleTree = false

            for(var i in this.$refs.subDropdowns){
                if(this.$refs.subDropdowns[i].classList)
                    this.$refs.subDropdowns[i].classList.add('hideIt')
            }
        })

        AZEventBus.$on('subBundleTreeItemClicked', msg => {  //this is for nodes in the subBundle tree off of the :: next to top level bundle name
            if(this.conts.id == msg.rootBundleId){
                
                this.data = msg.b
                this.showBundleTree = false
            }
        })

    },
    methods:{
       
       
        //Load bundle from breadcrumbs:
        subBack: function(id, index, bypass, b){
            if((this.breadCrumbs.length < 2 || id == this.conts.id) && !bypass) return
            this.data = b

            if(this.$parent.isPush){
                this.$parent.getDirtyCards(b.id)
            }
        },

        upLevel: function(){
            this.subBack(this.breadCrumbs[this.breadCrumbs.length -2].id, this.breadCrumbs.length - 2, true, this.breadCrumbs[this.breadCrumbs.length -2].b)
        },
        //

        //Load Sub Bundle:
        loadSub: function(b, ind){
            this.riseSubLabel(b, ind)
        },

        riseSubLabel: function(b, ind){
                
                //b.items.sort(function(a,b){ return a.p - b.p});
                //this.$refs.subLabel[ind].classList.remove('subLabelRise')
                this.conts.items = b.items
                

                this.$refs.subBundle.forEach(e => {
                    e.selectedForImport = false
                })
                this.$refs.subBundle[ind].selectedForImport = true

                this.$parent.forImportSelectedBundleId = b.id
                this.$parent.forImportSelectedOrigBundleId = b.origId


                /* if(this.$parent.isPush){
                    this.$parent.getDirtyCards(b.id)
                } */
            //}, 200)
        },
        //

      
       
        shareIt: function(){
            this.$root.app.doShowModal('ModalShare', {id: this.conts.id, branch: this.conts.branch})
        },
       
        openBundleTree: function(event){
            event.stopPropagation();
            this.showBundleTree = true
        },
        stopProp: function(event){
            event.stopPropagation();
        },

       /*  toggleAll: function(){
            if(this.includeAll){
                this.$refs.card.forEach(e => {
                    e.$refs.checkBox.checked = true
                    e.checkIt()
                    this.includeAll = false;
                })
            } else {
                this.$refs.card.forEach(e => {
                    e.$refs.checkBox.checked = false
                    e.uncheckIt()
                    this.includeAll = true;
                })
            }
        }, */

        checkAll: function(){
            this.$refs.card.forEach(e => {
                e.$refs.checkBox.checked = true
                /* e.toggleChecked() */
                e.checkIt()
                this.includeAll = false;
            })
        },

        unIncludeAll: function(){
            this.$refs.card.forEach(e => {
                e.$refs.checkBox.checked = false
                /*e.toggleChecked() */
                e.uncheckIt()
                this.includeAll = true;
            })
        }
      
    },
    computed: {
        rootBundle: function(){
           let ch = []

           if(this.$parent.isPush){
              let b = this.$root.app.treeNoInbox.find(e => {
                  return e.id == this.breadCrumbs[0].id
              })  

              return b.children
           } else {
               return this.data.children
           }

        },
        conts: function(){
           
            this.breadCrumbs = []

            var self = this;
  
            var tempo = []
            var found = false
            function processBreadCrumbs(id, arr){
               
                for(var x=0; x < arr.length; x++){

                    tempo.push({id: arr[x].id, listName: arr[x].listName, b: arr[x]})

                    if(arr[x].id == id){
                        self.breadCrumbs = tempo
                        found = true
                        break
                        return
                    } 

                    if(arr[x].children.length){
                        processBreadCrumbs(id, arr[x].children)
                    } else {
                        if(found == false) //not found in this bundle, pop it
                            tempo.pop()
                            
                        if(x == arr.length -1){ //checked all siblings, not found, pop parent as it is not part of path
                             tempo.pop()
                        } 
                    }
                }
            }


           
            if(!this.isUnCat){
                processBreadCrumbs(self.data.id, self.$parent.bundle)
            } else {
                this.breadCrumbs.push({id: 0, listName: 'In un-imported bundles', b: {}})
            }
            
            return this.data || {items: [], children: []}
        }   
    },
    watch:{
        info: function(){
            this.data = this.info;
        }
    }
}
</script>